export enum TagType {
  CHASE = 1,
  MASTERDOCUMENTSOURCE,
  DOCUMENT,
  MASTERDOCUMENTSOURCESPECIALHANDLING,
}
